import Constants from '../tools/constants.tools'

class TokenMiddleware {

  parseToken(token) {
    try {
      return JSON.parse(window.atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };

  verifyToken(token){
    if (this.parseToken(token).exp * 1000 > Date.now())
      return true;
    return false;
  }

  getToken() {
    const token = localStorage.getItem(Constants.USER_TOKEN);
    return token;
  }

  setToken(token) {
    localStorage.setItem(Constants.USER_TOKEN, token);
  }

  removeToken() {
    localStorage.removeItem(Constants.USER_TOKEN);
  }
}

export default new TokenMiddleware();
